import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Moves keyboard focus to the main landmark after each client-side
 * navigation and scrolls to the top, so assistive technology announces the
 * new page and the next Tab starts from its content rather than from the
 * link that was just used. The first render is left alone: stealing focus
 * on load is worse than doing nothing.
 */
export default function RouteFocus({ target = "main" }) {
  const { pathname } = useLocation();
  const previous = useRef(pathname);
  useEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;
    const node = document.getElementById(target);
    if (node) node.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, [pathname, target]);
  return null;
}
